export default __webpack_public_path__ + "static/media/Canucks.0978b1d1.png";